module.exports = __webpack_public_path__ + "static/img/img_download_app_store.bac32ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_download_app_store.svg
// module id = 311
// module chunks = 180